import { check } from "@xams-utils/check-types";

const saveRememberMe = (saved, { userId, orgId }, days = 28) => {
    const key = getKey(userId, orgId);

    if (saved && days>0) {
        if (key) {
            const value = getExpiryDate(days);
            localStorage.setItem(key, value);
        }
    } else {
        localStorage.removeItem(key);
    }
};

const getExpiryDate = (days) => {
    const currentDate = new Date();

    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + days);

    const futureTimestamp = futureDate.getTime();

    return futureTimestamp;
};

const checkRememberMe = ({ userId, orgId }) => {
    const key = getKey(userId, orgId);

    try {
        if (key) {
            const value = localStorage.getItem(key);
            return !checkIfExpired(value);
        }

        return false;
    } catch (e) {
        return false;
    }
};

const checkIfExpired = (timeStamp) => {
    const expiredTimeStamp = check.string(timeStamp)
        ? parseInt(timeStamp, 10)
        : timeStamp;

    if (check.number(expiredTimeStamp)) {
        const currentTimestamp = Date.now();

        return expiredTimeStamp < currentTimestamp;
    }

    return true;
};

const getKey = (userId, orgId) => {
    if (check.number(userId) && check.number(orgId)) {
        const key = `mfa-${userId}-${orgId}`;

        return key;
    }

    return null;
};

export { saveRememberMe, checkRememberMe };
